import AnimateWinsMediator from "ags/mediators/animate-wins-mediator";
import winMagnitude, { BigWinThresholds } from "ags/utils/win-magnitude";
import betModel from "slotworks/model/bets/bet-model";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import gameState from "slotworks/model/game-state";
import { LLWildBonusResult } from "integration/builders/result/ll-wild-bonus-result-builder";

export default class LightningBorderLoopWinsMediator extends AnimateWinsMediator {

    public startAnimating(winnings: number) {

        const winRatio = winnings / betModel.getTotalStake();
        const bigWinLevel = winMagnitude.getBigWinLevel(winRatio);
        const shouldAnimateWinningSymbols = (bigWinLevel >= BigWinThresholds.REGULAR && this.currentRecordHasSymbolWins()) || this.currentRecordHasBonusWin();

        if (shouldAnimateWinningSymbols) {
            lightningBorderAnimationUtil.stop();
        }

        return super.startAnimating(winnings);
    }

    public animateWinningSymbols() {

        const game = gameState.getCurrentGame().getCurrentRecord();
        const hasWildBonusResult = game.getResultsOfType(LLWildBonusResult).length > 0;

        if (hasWildBonusResult) {
            return;
        }

        super.animateWinningSymbols();
    }
}
